import { useQuery } from '@tanstack/react-query';

import { fetchTopSellers } from '../../services/analytics';

const formatCurrency = (value: number) => `₺${value.toFixed(2)}`;

export default function TopSellersLeaderboard() {
  const { data = [], error, isError, isLoading, isFetching } = useQuery({
    queryKey: ['analytics', 'top-sellers'],
    queryFn: () => fetchTopSellers(30, 15),
  });

  return (
    <div className="card">
      <div className="card-header">
        <div>
          <p className="card-title">En çok satanlar (30 gün)</p>
          <p className="card-subtitle">
            {isLoading || isFetching ? 'Satış verileri yükleniyor...' : `Ciroya göre sıralanan ${data.length} ürün`}
          </p>
        </div>
      </div>

      {isError ? (
        <div className="empty-state">
          <strong>Veriler yüklenemedi</strong>
          <p>{error instanceof Error ? error.message : 'Orders veya order_items tablolarına erişilemiyor.'}</p>
        </div>
      ) : data.length === 0 ? (
        <div className="empty-state">
          <strong>Henüz satış yok</strong>
          <p>Siparişler tamamlandığında liste güncellenecektir.</p>
        </div>
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Ürün</th>
              <th>Kategori</th>
              <th>Adet</th>
              <th>Ciro</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={item.productId}>
                <td>{index + 1}</td>
                <td>{item.productName}</td>
                <td>{item.category ?? '—'}</td>
                <td>{item.quantity}</td>
                <td>{formatCurrency(item.revenue)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
